var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navbar',{attrs:{"navbar-menu-classes":"navbar-right"}},[_c('template',{slot:"navbar-menu"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }